import { render, staticRenderFns } from "./EditarControlCambios.vue?vue&type=template&id=35e5cf4e&scoped=true&"
import script from "./EditarControlCambios.vue?vue&type=script&lang=js&"
export * from "./EditarControlCambios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e5cf4e",
  null
  
)

export default component.exports